import AppBadge from "elements/AppBadge";
import React from "react";
import { Card, CardBody } from "reactstrap";

const DisplayFieldSection = ({ field }) => {
  return (
    <Card className="border">
      <CardBody className="p-2">
        {field ? <AppBadge>{field}</AppBadge> : "No Field Selected"}
      </CardBody>
    </Card>
  );
};

export default DisplayFieldSection;
